import _uniqBy from 'lodash/uniqBy';

import { CountryUtils } from '../../../utils/CountryUtils';
import { TranslationId } from '../../../utils/translation.generated';

export type SupportedCountries = {
  countryTranslationKey: TranslationId;
  languageTranslationKey: TranslationId;
  countryCode: string;
  languageCode: string;
  locale: string;
  phoneCode: TranslationId;
};

export const supportedCountries: SupportedCountries[] = [
  {
    countryTranslationKey: 'general.country.Argentina',
    languageTranslationKey: 'general.language.Spanish',
    countryCode: CountryUtils.COUNTRY.ARGENTINA,
    languageCode: CountryUtils.LANGUAGE.SPANISH,
    locale: `${CountryUtils.LANGUAGE.SPANISH}_${CountryUtils.COUNTRY.ARGENTINA}`,
    phoneCode: 'general.phoneCode.Argentina',
  },
  {
    countryTranslationKey: 'general.country.Austria',
    languageTranslationKey: 'general.language.German',
    countryCode: CountryUtils.COUNTRY.AUSTRIA,
    languageCode: CountryUtils.LANGUAGE.GERMAN,
    locale: `${CountryUtils.LANGUAGE.GERMAN}_${CountryUtils.COUNTRY.AUSTRIA}`,
    phoneCode: 'general.phoneCode.Austria',
  },
  {
    countryTranslationKey: 'general.country.BelgiumFrench',
    languageTranslationKey: 'general.language.French',
    countryCode: CountryUtils.COUNTRY.BELGIUM,
    languageCode: CountryUtils.LANGUAGE.FRENCH,
    locale: `${CountryUtils.LANGUAGE.FRENCH}_${CountryUtils.COUNTRY.BELGIUM}`,
    phoneCode: 'general.phoneCode.Belgium',
  },
  {
    countryTranslationKey: 'general.country.BelgiumDutch',
    languageTranslationKey: 'general.language.Vlaas',
    countryCode: CountryUtils.COUNTRY.BELGIUM,
    languageCode: CountryUtils.LANGUAGE.DUTCH,
    locale: `${CountryUtils.LANGUAGE.DUTCH}_${CountryUtils.COUNTRY.BELGIUM}`,
    phoneCode: 'general.phoneCode.Belgium',
  },
  {
    countryTranslationKey: 'general.country.Brazil',
    languageTranslationKey: 'general.language.Portuguese',
    countryCode: CountryUtils.COUNTRY.BRAZIL,
    languageCode: CountryUtils.LANGUAGE.PORTUGUESE,
    locale: `${CountryUtils.LANGUAGE.PORTUGUESE}_${CountryUtils.COUNTRY.BRAZIL}`,
    phoneCode: 'general.phoneCode.Brazil',
  },
  {
    countryTranslationKey: 'general.country.Canada',
    languageTranslationKey: 'general.language.English',
    countryCode: CountryUtils.COUNTRY.CANADA,
    languageCode: CountryUtils.LANGUAGE.ENGLISH,
    locale: `${CountryUtils.LANGUAGE.ENGLISH}_${CountryUtils.COUNTRY.CANADA}`,
    phoneCode: 'general.phoneCode.Canada',
  },
  {
    countryTranslationKey: 'general.country.CzechRepublic',
    languageTranslationKey: 'general.language.Czech',
    countryCode: CountryUtils.COUNTRY.CZECH_REPUBLIC,
    languageCode: CountryUtils.LANGUAGE.CZECH,
    locale: `${CountryUtils.LANGUAGE.CZECH}_${CountryUtils.COUNTRY.CZECH_REPUBLIC}`,
    phoneCode: 'general.phoneCode.CzechRepublic',
  },
  {
    countryTranslationKey: 'general.country.Germany',
    languageTranslationKey: 'general.language.German',
    countryCode: CountryUtils.COUNTRY.GERMANY,
    languageCode: CountryUtils.LANGUAGE.GERMAN,
    locale: `${CountryUtils.LANGUAGE.GERMAN}_${CountryUtils.COUNTRY.GERMANY}`,
    phoneCode: 'general.phoneCode.Germany',
  },
  {
    countryTranslationKey: 'general.country.France',
    languageTranslationKey: 'general.language.French',
    countryCode: CountryUtils.COUNTRY.FRANCE,
    languageCode: CountryUtils.LANGUAGE.FRENCH,
    locale: `${CountryUtils.LANGUAGE.FRENCH}_${CountryUtils.COUNTRY.FRANCE}`,
    phoneCode: 'general.phoneCode.France',
  },
  {
    countryTranslationKey: 'general.country.GreatBritain',
    languageTranslationKey: 'general.language.English',
    countryCode: CountryUtils.COUNTRY.GREAT_BRITAIN,
    languageCode: CountryUtils.LANGUAGE.ENGLISH,
    locale: `${CountryUtils.LANGUAGE.ENGLISH}_${CountryUtils.COUNTRY.GREAT_BRITAIN}`,
    phoneCode: 'general.phoneCode.GreatBritain',
  },
  {
    countryTranslationKey: 'general.country.Hungary',
    languageTranslationKey: 'general.language.Hungarian',
    countryCode: CountryUtils.COUNTRY.HUNGARY,
    languageCode: CountryUtils.LANGUAGE.HUNGARIAN,
    locale: `${CountryUtils.LANGUAGE.HUNGARIAN}_${CountryUtils.COUNTRY.HUNGARY}`,
    phoneCode: 'general.phoneCode.Hungary',
  },
  {
    countryTranslationKey: 'general.country.Italy',
    languageTranslationKey: 'general.language.Italian',
    countryCode: CountryUtils.COUNTRY.ITALY,
    languageCode: CountryUtils.LANGUAGE.ITALIAN,
    locale: `${CountryUtils.LANGUAGE.ITALIAN}_${CountryUtils.COUNTRY.ITALY}`,
    phoneCode: 'general.phoneCode.Italy',
  },
  {
    countryTranslationKey: 'general.country.Japan',
    languageTranslationKey: 'general.language.Japanese',
    countryCode: CountryUtils.COUNTRY.JAPAN,
    languageCode: CountryUtils.LANGUAGE.JAPANESE,
    locale: `${CountryUtils.LANGUAGE.JAPANESE}_${CountryUtils.COUNTRY.JAPAN}`,
    phoneCode: 'general.phoneCode.Japan',
  },
  {
    countryTranslationKey: 'general.country.Lithuania',
    languageTranslationKey: 'general.language.Lithuanian',
    countryCode: CountryUtils.COUNTRY.LITHUANIA,
    languageCode: CountryUtils.LANGUAGE.LITHUANIAN,
    locale: `${CountryUtils.LANGUAGE.LITHUANIAN}_${CountryUtils.COUNTRY.LITHUANIA}`,
    phoneCode: 'general.phoneCode.Lithuania',
  },
  {
    countryTranslationKey: 'general.country.Netherlands',
    languageTranslationKey: 'general.language.Dutch',
    countryCode: CountryUtils.COUNTRY.NETHERLAND,
    languageCode: CountryUtils.LANGUAGE.DUTCH,
    locale: `${CountryUtils.LANGUAGE.DUTCH}_${CountryUtils.COUNTRY.NETHERLAND}`,
    phoneCode: 'general.phoneCode.Netherlands',
  },
  {
    countryTranslationKey: 'general.country.Poland',
    languageTranslationKey: 'general.language.Polish',
    countryCode: CountryUtils.COUNTRY.POLAND,
    languageCode: CountryUtils.LANGUAGE.POLISH,
    locale: `${CountryUtils.LANGUAGE.POLISH}_${CountryUtils.COUNTRY.POLAND}`,
    phoneCode: 'general.phoneCode.Poland',
  },
  {
    countryTranslationKey: 'general.country.Russia',
    languageTranslationKey: 'general.language.Russian',
    countryCode: CountryUtils.COUNTRY.RUSSIA,
    languageCode: CountryUtils.LANGUAGE.RUSSIAN,
    locale: `${CountryUtils.LANGUAGE.RUSSIAN}_${CountryUtils.COUNTRY.RUSSIA}`,
    phoneCode: 'general.phoneCode.Russia',
  },
  {
    countryTranslationKey: 'general.country.Ukraine',
    languageTranslationKey: 'general.language.Ukrainian',
    countryCode: CountryUtils.COUNTRY.UKRAINE,
    languageCode: CountryUtils.LANGUAGE.UKRAINIAN,
    locale: `${CountryUtils.LANGUAGE.UKRAINIAN}_${CountryUtils.COUNTRY.UKRAINE}`,
    phoneCode: 'general.phoneCode.Ukraine',
  },
  {
    countryTranslationKey: 'general.country.Usa',
    languageTranslationKey: 'general.language.English',
    countryCode: CountryUtils.COUNTRY.USA,
    languageCode: CountryUtils.LANGUAGE.ENGLISH,
    locale: `${CountryUtils.LANGUAGE.ENGLISH}_${CountryUtils.COUNTRY.USA}`,
    phoneCode: 'general.phoneCode.Usa',
  },
  ...(process.env.REACT_APP_ALLOW_FEATURE_TOGGLE === 'true'
    ? [
        {
          countryTranslationKey: 'general.country.India',
          languageTranslationKey: 'general.language.English',
          countryCode: CountryUtils.COUNTRY.INDIA,
          languageCode: CountryUtils.LANGUAGE.ENGLISH,
          locale: `${CountryUtils.LANGUAGE.ENGLISH}_${CountryUtils.COUNTRY.INDIA}`,
          phoneCode: 'general.phoneCode.India',
        },
        {
          countryTranslationKey: 'general.country.India',
          languageTranslationKey: 'general.language.Hindi',
          countryCode: CountryUtils.COUNTRY.INDIA,
          languageCode: CountryUtils.LANGUAGE.HINDI,
          locale: `${CountryUtils.LANGUAGE.HINDI}_${CountryUtils.COUNTRY.INDIA}`,
          phoneCode: 'general.phoneCode.India',
        },
        {
          countryTranslationKey: 'general.country.India',
          languageTranslationKey: 'general.language.Punjabi',
          countryCode: CountryUtils.COUNTRY.INDIA,
          languageCode: CountryUtils.LANGUAGE.PUNJABI,
          locale: `${CountryUtils.LANGUAGE.PUNJABI}_${CountryUtils.COUNTRY.INDIA}`,
          phoneCode: 'general.phoneCode.India',
        },
        {
          countryTranslationKey: 'general.country.India',
          languageTranslationKey: 'general.language.Telugu',
          countryCode: CountryUtils.COUNTRY.INDIA,
          languageCode: CountryUtils.LANGUAGE.TELUGU,
          locale: `${CountryUtils.LANGUAGE.TELUGU}_${CountryUtils.COUNTRY.INDIA}`,
          phoneCode: 'general.phoneCode.India',
        },
      ]
    : []),
];

export const supportedPhoneCodesPerCountry = (): SupportedCountries[] => {
  return _uniqBy(supportedCountries, 'countryCode');
};
